module.exports = __webpack_public_path__ + "static/media/Aalidhra14a1.605fe356.jpg";